import React, { Component, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { fetchEmployeePayrolls, resetEmployeePayrollData, seletcEmployeePayroll } from "../../Redux/Slices/ProcessPayrollSlice";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import {
  columnConfigForPayrollSummary,
  parseColumnConfig,
  parseColumnConfigContractorProcessPayrun,
  parseVisibleColumnConfig,
} from "../configs/config";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import PayrollService from "../../services/PayrollService";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { CONSTANTS, PAYMENT_MAP } from "../../constants/Constant";
import PayrollStepsManager from "./PayrollStepsManager";
import { DKButton, showToast, TOAST_TYPE, showAlert, showLoader, removeLoader } from "deskera-ui-library";
import ProcessPayrollHeader from "./ProcessPayrollHeader";
import TenantManager from "../../managers/TenantManager";
import MessageInfo from "../common/MessageInfo";
import Table from "../../services/table";
import SegmentListContainer from "../list/SegmentListContainer";
import { downloadAsZip, isIndiaCompliance, isUSCompliance } from "../../managers/common/CommonUtil";
import PayslipDesign from "../PayslipDesign/PayslipDesign";
import DocumentService from "../../services/DocumentService";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import ApiConstants from "../../constants/ApiConstants";
import { payloadCheckPrint } from "./temp-service";
import { COUNTRY } from "../../constants/CountryConstant";
import debounce from "../../utility/Debounce";
import { MODULE } from "../user-permissions/PermissionUtils";


const PayrollSummary = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: {},
        filter: {}
    };

    const initialPayrollFilters = [
      { id: 0, name: "All", key: "" },
      { id: 1, name: "Direct Deposit", key: "directDeposit" },
      { id: 2, name: "Cash", key: "cash" },
      { id: 3, name: "Cheque", key: "cheque" },
    ];

    const payrunId = PayrollStepsManager.getQueryParam(props.location, "id") || CONSTANTS.EMPTY_STRING;
    const navigatedFrom= PayrollStepsManager.getQueryParam(props.location, "navigatedFrom") || CONSTANTS.EMPTY_STRING;
    const step = PayrollStepsManager.getQueryParam(props.location, "step") || 0;
    const isContractor = PayrollStepsManager.getQueryParam(props.location, "isContractor") || "false";

    const [employeePayrolls, setEmployeePayrolls] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [showList, setFiltersList] = useState(true);
    const [payScheduleName, setPayScheduleName] = useState(CONSTANTS.EMPTY_STRING);
    const isActionEnabled = props.isAction;
    const [isPayrunProcessed, setPayrunStatus] = useState(false);
    const [paymentFailedCount, setFailedCount] = useState(0);
    const [payrollFilters, setPayrollFilters] = useState(initialPayrollFilters);
    const [initialValue, setFilterInitialValue] = useState(0);
    const [tenantData, setTenantData] = useState({});
    const [cashfreeWarningMsgs, setCashfreeMessages] = useState([]);
    const [payslipPayload, setPayslipPayload] = useState(null);
    var selected = [];
    const [refresh, setRefresh] = useState(0);
    const [searchStringValue, setSearchStringValue] = useState(CONSTANTS.EMPTY_STRING);
    const [reload, setReload] = useState(false);
    var intervalData;

    const dispatch = useDispatch();

    const employeePayrollsData = useSelector(seletcEmployeePayroll)

    const [isActionColumnEnabled, setIsActionColumnEnabled] = useState(false);
    const [isLoadPayrollData, setLoadPayrollData] = useState(false);

    useEffect(() => {
        RouteManager.setPresenter({ props });
        return () =>  {
          setEmployeePayrolls(initialState);
          dispatch(resetEmployeePayrollData());
        }
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(employeePayrollsData)) {
            if (employeePayrollsData.status === "idle" && navigatedFrom === "notification") {
                showToast("Payrun not available", TOAST_TYPE.FAILURE);
                RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID);
            } else if (employeePayrollsData.status !== "idle") {
                const summaryData = employeePayrollsData;
                const isProcessed = employeePayrollsData && employeePayrollsData.processed ? employeePayrollsData.processed : false;
                const failedCount = employeePayrollsData && employeePayrollsData.paymentFailureCount ? employeePayrollsData.paymentFailureCount : 0;
                const { tenant } = TenantManager.getPeopleTenantData();
                setTenantData(tenant);
                const isCashfreeEnabled = tenant && tenant.isCashfreeEnabled ? tenant.isCashfreeEnabled : false;
                setTenantData(tenant);
                setPayrunStatus(isProcessed);
                setFailedCount(failedCount);
                if (isIndiaCompliance()) {
                  let addtionalFilters = [{ id: 4, name: "UPI", key: "upi" }];
                  if (
                    isProcessed &&
                    isCashfreeEnabled &&
                    !Utility.isEmpty(parseInt(failedCount))
                  ) {
                    let group = { id: 5, name: "Failed Payments", key: "GET_PAYMENT_FAILED_PAYROLLS" };
                    addtionalFilters.push(group);
                  }
                  addtionalFilters.forEach((element) => {
                    let index = payrollFilters.findIndex(
                      (x) => x.id === element.id
                    );
                    if (index === -1) {
                      payrollFilters.push(element);
                    }
                  });
                  setPayrollFilters(payrollFilters);
                } else if (isUSCompliance()) {
                  let chequeFilter = payrollFilters.find(
                    (x) => x.name === CONSTANTS.CHEQUE
                  );
                  if (chequeFilter) chequeFilter.name = CONSTANTS.CHECK;
                }
                const {rowData, incompleteProfiles, cashfreeWarnings} = columnConfigForPayrollSummary(employeePayrollsData, isActionEnabled, isCashfreeEnabled, initialValue, isContractor);
                let processPayrollColumn;
                if (isContractor != "true") {
                  processPayrollColumn = parseVisibleColumnConfig(parseColumnConfig(
                    TableManger.getTableVisibleColumns(TABLES.PAYROLL_SUMMARY), TABLES.PAYROLL_SUMMARY
                  ));
                } else {
                  let columns = parseColumnConfigContractorProcessPayrun(
                    deepClone(
                      TableManger.getTableVisibleColumns(TABLES.PAYROLL_SUMMARY)
                    )
                  );
                  processPayrollColumn = parseVisibleColumnConfig(columns);
                }
                // let processPayrollColumn = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PAYROLL_SUMMARY))
                const passingData = {
                    columnData: deepClone(processPayrollColumn),
                    rowData,
                    filter: [],
                    originalData: employeePayrollsData
                };
                const isFilterListEnabled = employeePayrollsData.length > 0 ? true : false;
                setCashfreeMessages(cashfreeWarnings);
                setEmployeePayrolls(passingData);
                setTotalPageCount(employeePayrollsData.filter.totalPages);
                setCurrentPage(employeePayrollsData.filter.currentPage);
                setTotalCount(employeePayrollsData.filter.totalCount)
                setFiltersList(isFilterListEnabled);
                setPayScheduleName(employeePayrollsData.paySchedule.name)
            }
        }
    }, [employeePayrollsData,reload]);

    useEffect(() => {
        if (!Utility.isEmpty(payrunId)) {
          let searchString = getPaymentMethodKey(initialValue);
          let config = PayrollService.apiConfig;
          config = {
            ...config,
            Limit: 20,
            CurrentPage: 1,
            Order: "desc",
            Field: "_id",
            SearchField: "firstName",
            SearchString: searchStringValue,
            PaymentMethod: getPaymentMethod()
          };
          setIsActionColumnEnabled(TenantService.get(TENANT.IS_DIRECT_PAY_ENABLED) && initialValue === 3 && isUSCompliance());
          loadPayrollForFirstStep(config);
        }
    }, [payrunId, initialValue]);


    const onFilter = (updatedList, queries) => {

    }



    const loadPayrollForFirstStep = async (config) => {
        try {
          showLoader();
          PayrollService.apiConfig = config;
          await dispatch(fetchEmployeePayrolls(payrunId));
          setLoadPayrollData(true)
          removeLoader();
        } catch (err) {
          setLoadPayrollData(true)
          removeLoader();
          console.error('Error loading payrolls: ', err);
        }
    };

    const navigateToProcessPayroll =() => {
        if(step === 0 ) {
          if(isContractor === "true") {
            RouteManager.navigateToPage(PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST);
          } else {
            RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID);
          }
        } else {
                dispatchEvent(new CustomEvent('processDataUpdated', { detail: { payrollData: employeePayrollsData } }));
                RouteManager.navigateToPage(
                PAGE_ROUTES.PROCESS_PAYROLL,
                `module=${TABLES.PAYROLL}&origin=${PAGE_ROUTES.PAYROLL_GRID}&id=${payrunId}&step=${step}&isContractor=${isContractor}`,
        )
        }
    }

    const getBannerMessageForPayrunSummary = () => {
      let messageGroup = [
        {
          message: `Payment for <b>${paymentFailedCount}</b> employee(s) have failed. please`,
          isAction: true,
          action: (data) => onBannerClickAction(data),
          actionText: "click here",
          addtionalText: "to review and retry payment for the employees.",
        },
      ];
      return messageGroup;
    };

    const onBannerClickAction = (data) => {
        if(tenantData && tenantData.isCashfreeEnabled && paymentFailedCount > 0) {
            setFilterInitialValue(5);
            let config = PayrollService.apiConfig;
            loadPayrollForFirstStep({
              ...config,
              PaymentMethod: "GET_PAYMENT_FAILED_PAYROLLS",
            });
        }
    };

    const onRetryPayment = () => {
        showLoader("Payment initialization in progress...");
        Table.retryPayment(payrunId).finally(removeLoader()).then(
          (res) => {
            if (res) {
              showToast(
                "Payment Initiated successfully",
                TOAST_TYPE.SUCCESS
              );
              navigateToProcessPayroll();
            }
          },
          (err) => {
            showToast("Something went wrong", TOAST_TYPE.FAILURE);
          }
        );
    }

    const getPaymentPopUp = () => {
      let headerMsg = "This action is irreversible.";
      let msgText = "Are you sure you want to initiate payouts for these employees?";
      if (cashfreeWarningMsgs && cashfreeWarningMsgs.length > 0) {
        headerMsg = "Please verify below actions before initiating payouts";
        msgText = `<div class=''>${cashfreeWarningMsgs.map((f, i) =>`<div class='d-flex fs-r' style='justify-content:flex-start; padding-top:3px'>${i + 1}. ${f}</div>`).join('')}</div>`;
      }
      const processConfirm = [
        {
          title: "Not Now",
          className: "bg-gray1 border-m",
        },
        {
          title: cashfreeWarningMsgs.length > 0 ? "Yes, I've verified it!!!" : "Yes",
          className: "bg-app text-white ml-r",
          onClick: () => onRetryPayment(),
        },
      ];
      showAlert(
        headerMsg,
        msgText,
        processConfirm
      );
    }

    const onFilterSelect = (segment, index) => {
      setFilterInitialValue(segment.id);
    };

    const onColumnUpdate = (data) => {
      let { columnData } = data;
      Table.updateColumnPeople(
        columnData,
        TableManger.getTableId(TABLES.PAYROLL_SUMMARY)
      ).then((data) => {
        getColumns();
      });
    };

    const getColumns = () => {
      Table.getTable(TableManger.getTableId(TABLES.PAYROLL_SUMMARY)).then(
        (data) => {
          TableManger.setTableColumns(data, TABLES.PAYROLL_SUMMARY);
        },
        (err) => {}
      );
    };

    const onCheckPrint = () => {
        if (selected.length > 0) {
            showLoader("Downloading... Please wait");

            const employeeList = selected.map((e) => {
                return {
                    payrollPayrunId: e.id,
                    employeeId: e.employeeId
                }
            });

            const payload = {
                event: "PRINT",
                documentType: "PAYROLL_CHECK",
                tenantId: TenantService.getData().CONFIG.tenantId,
                payrunId: employeePayrollsData._id,
                employeeList: employeeList
            }

            DocumentService.checkPrintInfo(payload).then(
                (response) => {
                    if (response.code) {
                        let code = response.code;
                        if (response.documentTemplates?.length > 0) {
                            let defaultTemplate;
                            if (response.defaultTemplateMapping?.templateId) {
                                defaultTemplate = response.documentTemplates.find(t => t.id == response.defaultTemplateMapping.templateId);
                            }

                            if (defaultTemplate) {
                                code += `?tid=${defaultTemplate.id}`;
                            }
                        }

                        DocumentService.printDocByUID(code).then(
                            (pdfBlob) => {
                                removeLoader();
                                const workPeriod = DocumentService.getWorkPeriod(employeePayrollsData.workPeriod);
                                const pdf = new File([pdfBlob], `${workPeriod}_Checks.pdf`);
                                downloadAsZip([pdf], workPeriod);
                            }, (error) => {
                                removeLoader();
                                showAlert("Alert", "Internal server error");
                            }
                        );
                    } else {
                        removeLoader();
                        showAlert("Alert", "Internal server error");
                    }
                }, (error) => {
                    removeLoader();
                    showAlert("Alert", "Internal server error");
                }
            );
        } else {
            showAlert("Alert", "Please select only one employee");
        }
    }

    const onRowAdd = () =>{}

    const onDesignDocument = (payroll) => {
        if (payroll.rowData) {
            const payload = {
                event: "PRINT",
                documentType: "PAYROLL_CHECK",
                tenantId: TenantService.getData().CONFIG.tenantId,
                payrunId: payroll.rowData.payrunId,
                employeeList: [
                    {
                        payrollPayrunId: payroll.rowData.id,
                        employeeId: payroll.rowData.employeeId
                    }
                ]
            }

            DocumentService.designPayrollChequeDocument(payload).then(response => {
                if (response && response.code) {
                    const url = ApiConstants.PRODUCT_URL_DOCUMENT_BUILDER + response.code;
                    window.open(url, "_blank");
                }
            }, (error) => {
                showAlert("Alert", "Internal server error");
            })
        }
    }

    const openPreview = (payroll) => {
        listenCookieChange(({ oldValue, newValue }) => {
            console.log(`Cookie changed from "${oldValue}" to "${newValue}"`);
            setRefresh(refresh + 1)
        }, 1000);

        const payload = {
            body: {
                event: "PRINT",
                documentType: "PAYROLL_CHECK",
                tenantId: TenantService.getData().CONFIG.tenantId,
                payrunId: payroll.rowData.payrunId,
                employeeList: [
                    {
                        payrollPayrunId: payroll.rowData.id,
                        employeeId: payroll.rowData.employeeId
                    }
                ]
            },
            extra: {
                employeeName: payroll.rowData.employeeName,
                workPeriod: employeePayrollsData.workPeriod
            }
        }

        setPayslipPayload(payload);
    }

    const onSelection =(data)=>{
      selected = data
    }

    const onClose = () =>{
      if(intervalData) {
          clearInterval(intervalData);
      }
      setPayslipPayload(null)
    }
    const listenCookieChange=(callback, interval = 1000)=> {
      let lastCookie = document.cookie;
      intervalData = setInterval(()=> {
        let cookie = document.cookie;
        if (cookie !== lastCookie) {
          try {
            callback({oldValue: lastCookie, newValue: cookie});
          } finally {
            lastCookie = cookie;
          }
        }
      }, interval);
    }

    const getPaymentMethodKey = (initialValue) => {
      let searchString = "";
      let selectedFilter = payrollFilters.find(
        (filter) => filter.id === initialValue
      );
      if (selectedFilter) {
        searchString = selectedFilter.key;
      }
      return searchString;
    };

    const onSearch = (searchTerm) => {

      if (searchStringValue.length === 0 && !searchTerm.replace(/\s/g, '').length) {
        return;
      }
      searchTerm = searchTerm.trim();
      setSearchStringValue(searchTerm);
      let config = PayrollService.apiConfig;
      config = {
        ...config,
        SearchField: "firstName",
        SearchString: searchTerm,
        CurrentPage:  1,
        Limit: 20,
        Order: "desc",
        Field: "_id",
        PaymentMethod: getPaymentMethod()
      };
      loadPayrollForFirstStep(config);
  };
  const onSort = (data) => {
    
    let config = PayrollService.apiConfig;
    config = {
      ...config,
      Limit: 20,
      CurrentPage: (config&&config.CurrentPage) ? config.CurrentPage :1,
      Order: data.order.toLowerCase(),
      Field: data.columnData.columnCode,
      PaymentMethod: getPaymentMethod()
    };
    loadPayrollForFirstStep(config);
  }
  const getPaymentMethod = () => {
    const payment_method = payrollFilters.find(payment=>payment.id === initialValue)
    return payment_method?payment_method.key:payrollFilters[0].key
  };

    return (
      <>
        {payslipPayload &&
            <PayslipDesign
                payload={payslipPayload}
                documentUpdateCountRefresh={refresh}
                isPayrollCheque={true}
                onClose={() => {
                    onClose()
                }}
                {...props}
            />
        }
        <div className="column parent-width flex-1 parent-height">
            {employeePayrollsData && employeePayrollsData.payrolls ? (
                <div className="parent-width">
                    <div className="row"><h2 style={{ marginTop: 0 }}><b>{TABLE_DISPLAY_NAME[TABLES.PAYMENT_SUMMARY]}</b></h2></div>
                    <ProcessPayrollHeader isContractor={isContractor} />
                </div>
            ) : null}
            {isPayrunProcessed && tenantData && tenantData.isCashfreeEnabled && paymentFailedCount > 0 && (
                <div className="row">
              <MessageInfo
                message={getBannerMessageForPayrunSummary()}
                bannerClass="mb-l"
                isClosable={false}
              />
            </div>
            )}
            {isContractor != "true" && (
            <SegmentListContainer
              data={payrollFilters}
              selectedId={initialValue}
              onChange={onFilterSelect}
              // onClickNew={this.showAddSegmentPopup}
              maxWidth={React.createRef().current?.innerWidth}
              isAddEnabled={false}
            />
          )}
            <div className="column parent-width mb-s position-relative flex-1 ">
                <DataGridHolderPayroll
                    tableName={TABLES.PAYROLL_SUMMARY}
                    displayTableName={TABLE_DISPLAY_NAME[TABLES.PAYMENT_SUMMARY]}
                    allowRowEdit={false}
                    allowColumnEdit={true}
                    allowRowAdd={false}
                    allowColumnAdd={false}
                    allowColumnDelete={true}
                    allowColumnShift={false}
                    allowSearch={true}
                    allowFilter={false}
                    onDownloadAttachment={(data) => {
                      openPreview(data)
                    }}
                    onDesignDocument={(data)=>{
                        onDesignDocument(data)
                    }}
                    allowDataExport={true}
                    gridData={isLoadPayrollData ? employeePayrolls: initialState}
                    onFilter={onFilter}
                    filter={employeePayrolls.filter}
                    currentPage={currentPage}
                    totalPageCount={totalPageCount}
                    isActionEnabled={isActionColumnEnabled}
                    onColumnUpdate={onColumnUpdate}
                    onSelection={onSelection}
                    isActionColumnFirst={isActionColumnEnabled}
                    isCheckPrint={isActionColumnEnabled}
                    isMenuVisible={isActionColumnEnabled}
                    onCheckPrint={()=>{
                      onCheckPrint()
                    }}
                    onSearch={debounce(onSearch,500)}
                    addMenuButton={[]}
                    onCancelContext={() => {
                        const gridData = deepClone(employeePayrolls);
                        gridData.rowData = gridData.rowData.map((d) => {
                            return { ...d, selected: false }
                        });

                        setEmployeePayrolls(gridData);
                    }}
                    onPaginationClick={(requestedPageNumber) => {
                      const config = {
                        Order: "desc",
                        Field: "_id",
                        ...PayrollService.apiConfig,
                        CurrentPage: requestedPageNumber,
                        Limit: 20,
                        
                        SearchField: "firstName",
                        SearchString: searchStringValue,
                        PaymentMethod: getPaymentMethod()
                      };
                      loadPayrollForFirstStep(config);
                    }}
                    onSort={onSort}
                    onColumnShift={(data)=> setReload(!reload)}
                    module={MODULE.PAYRUN}
                />
            </div>
            <div className="row pb-xl">
                <DKButton
                    title={"Cancel"}
                    className="border-m ml-r bg-gray1"
                    onClick={() => navigateToProcessPayroll()}
                />
                {isPayrunProcessed && tenantData && tenantData.isCashfreeEnabled && paymentFailedCount > 0 && initialValue === 5 && (<DKButton
                    title={"Retry Payment"}
                    className="border-m ml-r bg-app text-white"
                    onClick={() => getPaymentPopUp()}
                />)}
            </div>
        </div>
        </>
    )

}

export default PayrollSummary;